module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInLeft dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué pasa si sus ingresos son menores a sus gastos?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(" ¿Qué pasa si sus ingresos "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("son menores a")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" sus gastos? ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Flujo de caja en rojo',
      "videoEmbed": "ADMINISTRACIONDINERO42FlujoCajaEnRojo.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only aligner",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInDown",
    attrs: {
      "imaSize": 40,
      "imaSrc": "design/banco3-1-1_3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Si sus ingresos son menores a sus gastos, "), _c('strong', [_vm._v("su flujo de caja está en rojo")]), _vm._v(", sus\n        "), _c('strong', [_vm._v("deudas")]), _vm._v(" podrían aumentar y está en problemas o gastando sus ahorros.\n        En últimas, "), _c('strong', [_vm._v("su patrimonio puede disminuir")]), _vm._v(".\n      ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "mb-5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 397,
      "imaSrc": "contenido/diapositiva_43",
      "imaAlt": "Flujo de caja en rojo, disminución de ahorros"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa02a19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-42.vue
// module id = 1014
// module chunks = 1